import { get } from '../../config/api/Api';
import {
  IFinalResponse,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
} from '../../types';

const ENDPOINT_API_PATH = 'sdk/evalx/:idAplication/users/:userBase64';
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'NOT_CREDENTIALS';

type ParamsTypes = {
  idAplication: string;
  userBase64: string;
};

const call = async (
  pathParameters: ParamsTypes,
  environmentLD: string,
): Promise<IFinalResponse> => {
  const result: IFinalResponse = {
    success: false,
    data: null,
    errors: undefined,
    metadata: null,
  };

  try {
    const init: InitApiType = {
      pathParameters: {
        ...pathParameters,
      },
    };

    let EndPointName: EndPointsNames = 'ApiLaunchdarklyRelay';
    if (environmentLD === 'BLUE') {
      EndPointName = 'ApiLaunchdarklyRelayBLUE';
    } else if (environmentLD === 'GREEN') {
      EndPointName = 'ApiLaunchdarklyRelayGREEN';
    } else if (environmentLD.includes('-N')) {
      EndPointName = 'ApiLaunchdarklyRelayNew';
    }

    const response = await get(
      EndPointName,
      ENDPOINT_API_PATH,
      API_CREDENTIALS_TYPE,
      init,
    );
    result.success = true;
    result.data = response.response['api-data'].value;
  } catch (error) {
    result.success = false;
    result.data = null;
    result.errors = [error];
  }

  return result;
};

export default { call };
